angular.module 'zc.core'

.filter "showElement", ($sce) ->
  (message, column) ->
    value = message[column.name]
    if value
      html = switch column.type
        when "image" then "<div><image src=\"#{value}\"></div>"
        when "color" then "<div><div style=\"background-color:#{value}; width: 24px; height:24px; display:inline-block\"></div> <span>#{value}</span></div>"
        when "url" then "<div style=\"background-color:#{value};\"><a href=\"#{value}\" target=\"_blank\">#{value}</a></div>"
        when "duration" then "<div>#{value}min</div>"
        else "<div>#{value}</div>"
      $sce.trustAsHtml html
    else
      "empty"



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/filters/show_element.filter.coffee